export default {
  async created() {
    const { showChatForExtensions, hidePhoneForExtensions } = await romeApi.get('/config/appsettings?keys=ShowChatForExtensions&keys=HidePhoneForExtensions');
    this.showChatForExtensions = showChatForExtensions;
    this.hidePhoneForExtensions = hidePhoneForExtensions;
  },
  data() {
    return {
      showChatForExtensions: '',
      hidePhoneForExtensions: ''
    }
  },
  methods: {
    shouldHidePhoneForExtension(extension) {
      if (!extension || extension.length === 0) return true;
      return this.hidePhoneForExtensions.includes(extension);
    },
    shouldShowChatForExtension(extension) {
      if (!extension || extension.length === 0) return false;
      return this.showChatForExtensions.includes(extension);
    }
  }
}



// WEBPACK FOOTER //
// ./src/framework/utils/ameriflex-specialists-mixin.js